import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const authHeaders = () => {
    const t = localStorage.getItem('token');
    return t ? { Authorization: `Bearer ${t}` } : {};
};

export const searchDirectory = (q = '', statusFilter = null, limit = 50) => {
    const params = new URLSearchParams();
    if (q) params.set('q', q);
    if (statusFilter) params.set('status_filter', statusFilter);
    if (limit) params.set('limit', String(limit));
    return axios.get(`${API}/customer-directory/search?${params.toString()}`, {
        headers: authHeaders()
    });
};

export const getCustomerDetail = (customerId) =>
    axios.get(`${API}/customer-directory/customer/${customerId}`, { headers: authHeaders() });

export const editCustomer = (customerId, payload) =>
    axios.put(`${API}/customer-directory/customer/${customerId}`, payload, { headers: authHeaders() });

export const addCustomerNote = (customerId, text, source = 'directory') =>
    axios.post(
        `${API}/customer-directory/customer/${customerId}/notes`,
        { text, source },
        { headers: authHeaders() }
    );

export const markCertificateUsed = (itemId) =>
    axios.post(`${API}/customer-directory/sale-items/${itemId}/mark-used`, {}, { headers: authHeaders() });

export const unmarkCertificateUsed = (itemId) =>
    axios.post(`${API}/customer-directory/sale-items/${itemId}/unmark-used`, {}, { headers: authHeaders() });

export const resendCertificate = (itemId, channel, type) =>
    axios.post(
        `${API}/customer-directory/sale-items/${itemId}/resend`,
        { channel, type },
        { headers: authHeaders() }
    );

export const cancelCertificate = (itemId, reason, refundMethod = 'original') =>
    axios.post(
        `${API}/customer-directory/sale-items/${itemId}/cancel`,
        { reason, refund_method: refundMethod },
        { headers: authHeaders() }
    );

export const cancelSale = (saleId, reason, refundMethod = 'original') =>
    axios.post(
        `${API}/customer-directory/sales/${saleId}/cancel`,
        { reason, refund_method: refundMethod },
        { headers: authHeaders() }
    );
